import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginPageComponent } from './Components/login-page/login-page.component';
import { MyDayComponent } from './Components/my-day/my-day.component';
import { PortInfopageComponent } from './Components/port-infopage/port-infopage.component';
import { ContactPageComponent } from './Components/contact-page/contact-page.component';
import { PortalPageComponent } from './Components/portal-page/portal-page.component';
import { ShipinfoPageComponent } from './Components/shipinfo-page/shipinfo-page.component';
import { FAQPageComponent } from './Components/faq-page/faq-page.component';
import { MealActivityPageComponent } from './Components/meal-activity-page/meal-activity-page.component';
import { CrewPageComponent } from './Components/crew-page/crew-page.component';
import { ShiplocationPageComponent } from './Components/ship-location-page/ship-location-page.component';
import { MealDescriptionPageComponent } from './Components/meal-description-page/meal-description-page.component';
import { OnboardRebookingPageComponent } from './Components/onboard-rebooking-page/onboard-rebooking-page.component';
import { EagleSocietyPageComponent } from './Components/eagle-society-page/eagle-society-page.component';
import { EntertainmentActivityPageComponent } from './Components/entertainment-activity-page/entertainment-activity-page.component';
import { ShoreExcursionsPageComponent } from './Components/shore-excursions-page/shore-excursions-page.component';
import { PCIPageComponent } from './Components/pci-page/pci-page.component';
import { ItineraryExplorerPageComponent } from './Components/itinerary-explorer-page/itinerary-explorer-page.component';
import { AdminLoginPageComponent } from './Components/admin-login-page/admin-login-page.component';
import { ShipSelectComponent } from './Components/ship-select/ship-select.component';
import { ShipDropdownListComponent } from './Components/ship-dropdown-list/ship-dropdown-list.component';
import { CafeDescriptionPageComponent } from './Components/cafe-description-page/cafe-description-page.component';
import { LocalloopPageComponent } from './Components/localloop-page/localloop-page.component';
import { LogoutComponent } from './Components/logout/logout.component';
import { EnrichmentGuidePointsofinterestPageComponent } from './Components/enrichment-guide-pointsofinterest-page/enrichment-guide-pointsofinterest-page.component';
import { TripContextGuard } from './guards/trip-context.guard';
import { PageNotFoundComponent } from './Components/page-not-found/page-not-found.component';

const g = { canActivate: [TripContextGuard] };

const routes: Routes = [
  { path: 'login', component: LoginPageComponent },
  { path: 'myday', component: MyDayComponent, ...g },
  { path: 'portinfo', component: PortInfopageComponent, ...g },
  { path: 'contact', component: ContactPageComponent, ...g },
  { path: 'menu', component: PortalPageComponent, ...g },
  { path: 'shipinfo', component: ShipinfoPageComponent, ...g },
  { path: 'faq', component: FAQPageComponent, ...g },
  { path: 'meal', component: MealActivityPageComponent, ...g },
  { path: 'crew', component: CrewPageComponent, ...g },
  { path: 'shiplocation/:dplDeck', component: ShiplocationPageComponent, ...g },
  { path: 'mealdescription', component: MealDescriptionPageComponent, ...g },
  { path: 'rebook', component: OnboardRebookingPageComponent, ...g },
  { path: 'eagle', component: EagleSocietyPageComponent, ...g },
  { path: 'entertain', component: EntertainmentActivityPageComponent, ...g },
  { path: 'excursions', component: ShoreExcursionsPageComponent, ...g },
  { path: 'pci', component: PCIPageComponent, ...g },
  { path: 'ItinExplorer', component: ItineraryExplorerPageComponent, ...g },
  { path: 'cafedescription', component: CafeDescriptionPageComponent, ...g },
  { path: 'localloop/:itiCode', component: LocalloopPageComponent, ...g },
  { path: 'enrichmentguide', component: EnrichmentGuidePointsofinterestPageComponent, ...g },
  { path: '', redirectTo: '/menu', pathMatch: 'full' },
  { path: 'adminlogin', component: AdminLoginPageComponent },
  { path: 'shipselect', component: ShipSelectComponent },
  { path: 'dropdownlist', component: ShipDropdownListComponent },
  { path: 'logout', component: LogoutComponent },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
